import { gql } from '@apollo/client'

const ANNOUNCES_FRAGMENT = gql`
    fragment AnnouncesFragment on Announce {
	    article_id
        article_title
        article_date
        article_body
        occurs_from
        occurs_till
        article_lead
        categories{
            list_id
            list_title
        }
    }
`;


export const GET_ANNOUNCES = gql`
	${ANNOUNCES_FRAGMENT}
    query Announces($ids: String $fd: String $td: String $list_ids: String $ids_arr: [Int] $list_ids_arr: [Int] $start_after_id: Int $limit: Int $q: String $solr_url: String $priority: Int $start: Int){
        announces(ids: $ids, ids_arr: $ids_arr, fd: $fd, td: $td, list_ids: $list_ids,  list_ids_arr:$list_ids_arr, start_after_id: $start_after_id, limit: $limit, q: $q, solr_url: $solr_url, priority: $priority, start: $start) {
            ...AnnouncesFragment
        }
    }
`;

export const GET_ANNOUNCE = gql`
    ${ANNOUNCES_FRAGMENT}
    query Announce($article_id: ID!){
        announce(article_id: $article_id) {
            ...AnnouncesFragment
        }
    }
`;

export const GET_ANNOUNCES_COUNT = gql`
    query resultCounter($ids: String $fd: String $td: String $list_ids: String $ids_arr: [Int] $list_ids_arr: [Int] $q: String $solr_url: String $priority: Int $start: Int){
        resultCounter(ids: $ids, ids_arr: $ids_arr, fd: $fd, td: $td, list_ids: $list_ids,  list_ids_arr:$list_ids_arr, q: $q, solr_url: $solr_url, priority: $priority, start: $start) 
    }
`;


export const GET_CATEGORIES = gql`
    query categories {
        categories {
            list_title
            list_id
            list_sid
            list_announce
        }
    }
`;